import { h } from 'preact';

import MovieEditor from 'components/editor/movies/movieEditor';

import s from 'components/editor/movies/movieFooter/movieFooter.sss';

const COPYRIGHT_DATE = window?.__BUILD_DATE__ ? new Date(window.__BUILD_DATE__) : new Date();

export default class MoviePageFooter extends MovieEditor {
	s = s;
	copyrightYear = COPYRIGHT_DATE.getFullYear();

	get footerPath() {
		return `${this.props.dataRoot}/content/footer`;
	}

	// MUST OVERRIDE
	renderVisual() {}

	// MUST OVERRIDE
	renderSettings() {}
}
